import { PopperController } from "./popper";

export class PopperRightClickTriggerController {
  public popperCtrl: PopperController;
  constructor() {}

  public togglePopper($event: any) {
    if (($event && $event.which && $event.which === 3) || ($event.button && $event.button === 2)) {
      this.popperCtrl.togglePopper();
    }
  }
}

export const sdPopperRightClickTrigger: ng.IComponentOptions = {
  controller: PopperRightClickTriggerController,
  require: {
    popperCtrl: "^sdPopper"
  },
  transclude: true,
  template: `<div class="sd-popper-trigger" ng-mouseup="$ctrl.togglePopper($event)" keyboard-activation="$ctrl.togglePopper()" tabindex="0">
                <ng-transclude></ng-transclude>
              </div>`
};
